import { SettingKey } from '@models/Setting'
import { saveSetting } from '@services/SettingService'
import { useAppSelector } from '@store/hooks'
import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import Update from './Update'

export const SettingForm: SBRMForm = forwardRef(({ formProps }, ref) => {
  const { error } = useAppSelector((state) => state.setting)

  return (
    <SBRM.BaseEntityForm
      {...{ ref, formProps }}
      error={error && String(error)}
      formActions={{
        update: Update,
      }}
      handlers={{
        update: async (values) => {
          if (values.key === SettingKey.CHAT_VISIBILITY) {
            // Special case for boolean values
            return saveSetting({
              ...values,
              value: values.value ? '1' : '0',
            })
          }
          await saveSetting(values)
          return true
        },
      }}
    />
  )
})

SettingForm.displayName = 'SettingForm'

export default SettingForm
